import { ApiService } from '../../types/api';

export type CountryRegion = {
  code: string;
  name: string;
};

export interface CountriesApiContract {
  regions(code: string): Promise<CountryRegion[]>;
}

declare module '../../context/page-context' {
  interface Apis {
    countries: CountriesApiContract;
  }
}

type CountriesResponse = {
  regions: CountryRegion[];
};

export class CountriesApi extends ApiService implements CountriesApiContract {
  public regions(code: string): Promise<CountryRegion[]> {
    return this.api
      .proxy<CountriesResponse>({
        method: 'GET',
        path: '/v1/countries/{id}',
        params: { id: code },
      })
      .then((response) => response.regions);
  }
}
